import { Briefcase } from "lucide-react";
import { Reveal } from "./Reveal";
import { EXPERIENCE, CONTRACTOR_NOTE } from "../../data/content";

export const Timeline = () => (
  <section id="experience" data-testid="experience-section" className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-40">
    <Reveal className="max-w-3xl">
      <p className="overline text-terracotta">(04) — Track Record</p>
      <h2 className="mt-6 font-serif text-5xl md:text-7xl tracking-tight leading-[0.95] text-ink">
        Thirteen years,
        <br />
        one throughline.
      </h2>
    </Reveal>

    <Reveal delay={0.1}>
      <div className="mt-10 flex flex-col md:flex-row items-start gap-5 rounded-2xl border border-line bg-sand p-7 md:p-9 max-w-4xl">
        <span className="grid place-items-center w-11 h-11 shrink-0 rounded-full bg-ink text-paper">
          <Briefcase size={18} />
        </span>
        <p className="text-base md:text-lg text-stone leading-relaxed">
          <span className="text-ink font-medium">For recruiters:</span>{" "}
          {CONTRACTOR_NOTE.replace("For recruiters: ", "")}
        </p>
      </div>
    </Reveal>

    <div className="mt-16 md:mt-20 border-t border-line max-w-5xl">
      {EXPERIENCE.map((e, i) => (
        <Reveal key={i} delay={(i % 4) * 0.05}>
          <div className="group grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-8 py-8 border-b border-line hover:bg-sand/60 transition-colors duration-300 -mx-4 px-4 rounded-lg">
            <div className="md:col-span-3">
              <span className="overline text-terracotta">{e.period}</span>
            </div>
            <div className="md:col-span-9">
              <h3 className="font-serif text-2xl md:text-3xl tracking-tight text-ink leading-tight">
                {e.role}
              </h3>
              <p className="mt-0.5 text-sm uppercase tracking-[0.14em] text-stone">{e.company}</p>
              <p className="mt-3 text-base text-stone leading-relaxed max-w-2xl">{e.note}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
